import { injectIntl } from 'react-intl';
import SortableTable from './SortableTable';

export default injectIntl(SortableTable);
